const IconBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M2 2h20v20H2z" />
    <path d="M0 0v24h24V0zm22 22H2V2h20z" fill="#333" />
    <path
      fill="#333"
      d="M12 13.646l1.545.854-.295-1.809 1.25-1.281-1.727-.264L12 9.5l-.773 1.646-1.727.264 1.25 1.281-.295 1.809L12 13.646z"
    />
  </svg>
);

export default IconBlockIcon;
